import React from 'react'
import { Route } from 'react-router'
import { FullScreenLoader } from '../../components/Loader'
import { TemplateType } from '../Routes'

const Loader = () => (
  <FullScreenLoader style={{ height: 'calc(100vh - 56px)', width: '100vw' }} />
)

function withLazyLoadingScope(componentPath: string, scope = undefined, template = TemplateType.Old) {
  const Component = React.lazy(() => import(`../../screens/${componentPath}`))

  return {
    C: function(props) {
      return (
        <React.Suspense fallback={<Loader />}>
          <Route
            {...props}
            render={() => <Component {...props} mobile={props.mobile} />}
          />
        </React.Suspense>
      )
    },
    scope: scope,
    template:template,
  }
}

function LazyRoute(componentPath: string) {
  const Component = React.lazy(() => import(`../../screens/${componentPath}`))

  return function(props) {
    return (
      <React.Suspense fallback={<Loader />}>
        <Route
          {...props}
          render={() => <Component {...props} mobile={props.mobile} />}
        />
      </React.Suspense>
    )
  }
}

export { withLazyLoadingScope }
export default LazyRoute
